import { motion } from "framer-motion";
import dosaImage from "../assets/Dosa about us main photo.png";

export default function About() {
    const fadeUp = {
        hidden: { opacity: 0, y: 30 },
        visible: (i = 1) => ({
            opacity: 1,
            y: 0,
            transition: { delay: i * 0.15, duration: 0.6, ease: "easeOut" },
        }),
    };

    const values = [
        { title: "Tradition in Taste", text: "Authentic regional recipes, perfected over generations." },
        { title: "Royal Presentation", text: "Every setup designed with elegance and detail." },
        { title: "Personalized Experience", text: "Menus curated to reflect your vision and culture." },
        { title: "Excellence in Service", text: "Hospitality that feels as warm as home." },
    ];

    return (
        <section
            id="about"
            className="bg-white text-[#1F2937] py-24 px-6 md:px-20"
        >
            {/* Header */}
            <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={fadeUp}
                className="text-center mb-12"
            >
                <span
                    className="px-6 py-2 text-sm font-semibold tracking-wide rounded-full shadow-md inline-block mb-4"
                    style={{
                        background: "linear-gradient(135deg, #D4AF37 0%, #e0c168 50%, #B88A2D 100%)",
                        color: "#FFFFFF",
                    }}
                >
                    ABOUT US
                </span>

                <h2
                    className="
                        font-[Playfair_Display] font-semibold
                        text-[2.4rem] md:text-[2.9rem] lg:text-[3.2rem]
                        leading-tight
                        text-[#1F2937]
                        "
                >
                    <span className="text-[#D4AF37]">Amantranaa </span>– A Warm Invitation to{" "}
                    <span className="text-[#D4AF37]">Taste & Tradition</span>
                </h2>

            </motion.div>

            {/* Content */}
            <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-start">
                {/* Text */}
                <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={fadeUp}
                >
                    <p className="text-lg leading-relaxed text-[#4B5563] mb-6 italic">
                        Derived from the Sanskrit word{" "}
                        <span className="text-[#D4AF37] font-semibold">Amantranaa</span>, meaning{" "}
                        <em>“invitation”</em> or <em>“warm welcome”</em>, our name reflects our philosophy —
                        every meal is an invitation to experience{" "}
                        <span className="text-[#D4AF37]">love, culture, and celebration</span>.
                    </p>

                    <p className="text-lg leading-relaxed text-[#4B5563] mb-8">
                        At{" "}
                        <span className="text-[#D4AF37] font-semibold">Amantranaa Caterers</span>, we craft
                        culinary experiences that blend{" "}
                        <span className="text-[#D4AF37]">tradition</span> with{" "}
                        <span className="text-[#D4AF37]">elegance</span>. From handcrafted thalis to curated
                        buffets, every dish embodies the{" "}
                        <span className="text-[#D4AF37]">richness of Indian heritage</span> — served with
                        grace, warmth, and a royal touch.
                    </p>

                    {/* Values */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-6">
                        {values.map((item, i) => (
                            <motion.div
                                key={i}
                                variants={fadeUp}
                                custom={i}
                                className="border-l-4 pl-4 rounded-lg bg-[#F9FAFB] hover:bg-[#F3F4F6] transition-all"
                                style={{
                                    borderColor: "#D4AF37",
                                    boxShadow: "inset 3px 0 6px rgba(212,175,55,0.4)",
                                }}
                            >
                                <h4 className="text-[#1F2937] font-semibold text-lg mb-1">
                                    {item.title}
                                </h4>
                                <p className="text-sm text-[#6B7280]">
                                    {item.text}
                                </p>
                            </motion.div>
                        ))}
                    </div>
                </motion.div>

                {/* Image */}
                <motion.div
                    initial={{ opacity: 0, x: 40 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                    viewport={{ once: true }}
                    className="flex justify-center md:justify-end"
                >
                    <img
                        src={dosaImage}
                        alt="Amantranaa South Indian Cuisine"
                        className="rounded-2xl shadow-lg w-full max-w-md border border-[#D4AF37]/40"
                    />
                </motion.div>
            </div>
        </section>
    );
}
